import { ReactNode } from "react";

export default function Eyebrow({ children }: { children: ReactNode }) {
  return (
    <div className="eyebrow">
      <span>{children}</span>
    </div>
  );
}
